@if (builder.assistAvailable()) {
  <div
    class="ai-assist-track"
    data-testId="ai-builder-toggle-group"
  >
    <button
      [attr.aria-pressed]="builder.assistRequested()"
      [attr.aria-label]="builder.assistRequested() ? 'Close AI assistant' : 'Build with AI'"
      [pTooltip]="builder.assistRequested() ? 'Close AI assistant — ⌘K' : 'Build with AI — ⌘K'"
      (click)="builder.toggle()"
      class="flx-ds ai-assist-toggle"
      flxButton
      icon="center"
      tooltipPosition="bottom"
      type="button"
      data-testId="ai-builder-toggle"
    >
      <i
        [class]="builder.assistRequested() ? 'ph-fill' : 'ph'"
        class="ph-sparkle"
        flxIcon
        aria-hidden="true"
      ></i>
    </button>

    @if (builder.assistRequested()) {
      <hr class="w-px h-4 mx-0.5 shrink-0 border-0 bg-white/[0.18]" />
      <span
        id="ai-builder-view-label"
        class="sr-only"
      >
        AI builder view
      </span>
      <flx-segmented-button
        [ngModel]="builder.view()"
        (segmentSelect)="builder.openView($event)"
        class="flx-ds small dark neutral animate-builder-mode-in motion-reduce:animate-none"
        describeById="ai-builder-view-label"
      >
        @for (view of views; track view.value) {
          <button
            [pTooltip]="view.title"
            [value]="view.value"
            attr.data-testId="ai-builder-view-{{ view.value }}"
            flxSegmentedOption
            tooltipPosition="bottom"
            type="button"
          >
            {{ view.label }}
          </button>
        }
      </flx-segmented-button>
    }
  </div>
}
